var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"shareable-link-page"},[_c('div',{staticClass:"sharebale-line-container"},[(!_vm.isLoaded)?_c('b-spinner'):_c('div',[_c('page-not-found')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }